// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"1189":"editor","3161":"CustomWidgetBuilder"}[chunkId] || chunkId) + "." + {"452":"571862ea","1189":"ea0bfdc6","2541":"34901d22","2666":"369a759a","2913":"ecaf8fc4","3161":"46e183d6","3285":"1ef3f7ac","5893":"2e3b0847","7517":"72de19bd","8285":"7a4ff437"}[chunkId] + ".chunk.css";
};